import {HttpClient} from '../../../core/request'


export const contactUs = (email, name, message, phone) => {
    return HttpClient().post('contact-us', {
        email: email,
        name: name,
        message: message,
        phone: phone,
    });
};


// WEBPACK FOOTER //
// ./src/routes/ContactUs/modules/contact.js